import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "about" }
const _hoisted_3 = { class: "categories" }
const _hoisted_4 = { class: "services" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "copy" }, "© 2023 - micolist. All Rights Reserved.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ias" }, [
  /*#__PURE__*/_createElementVNode("a", {
    title: "IAS Digital Group",
    href: "https://iasdigitalgroup.com",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://iasdigitalgroup.com/img/logo-websites.png",
      title: "IAS Digital Group",
      alt: "IAS Digital Group"
    })
  ])
], -1)

import { onBeforeMount, ref } from "vue";
import { listCategories } from "@/services/portalService";
import { CategoryItem } from "@/models/Category";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheFooter',
  setup(__props) {

const categories = ref<CategoryItem[]>([]);

const fetchData = async () => {
  categories.value = await listCategories();
};

onBeforeMount(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("footer.about.title")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { name: 'terms' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("terms.title")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { name: 'privacy' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("privacy.title")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { name: 'contact' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("contact.title")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("footer.categories.title")), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
            return (_openBlock(), _createElementBlock("li", {
              key: cat.hid
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'category', params: { category: cat.slug } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(cat.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("footer.services.title")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { name: 'sign-in' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("sign-in.title")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { name: 'publicity' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("publicity.title")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: { name: 'register' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("register.title")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _hoisted_5,
    _hoisted_6
  ]))
}
}

})